import React from 'react';
import UserFilterCard from '../../ChartFieldFilter/UserFilterCard';
import UserFilterCardForDm from '../../ChartFieldFilter/UserFilterCardForDm';
import { DynamicMeasureProps } from './DynamicMeasuresInterfaces';

interface ChartFilterCardsProps {
  chartType: string;
  selectedDynamicMeasureProps?: DynamicMeasureProps;
  currentChartAxes: any;
  bIndex: number;
  uID?: string;
  name: string;
  dynamicMeasureState: any;
  propKey: string;
  isFilterCollapsed: boolean;
}

const ChartFilterCards: React.FC<ChartFilterCardsProps> = ({
  chartType,
  selectedDynamicMeasureProps,
  currentChartAxes,
  bIndex,
  uID,
  name,
  dynamicMeasureState,
  propKey,
  isFilterCollapsed,
}) => {
  return (
    <>
      {chartType === 'richText'
        ? selectedDynamicMeasureProps?.chartAxes[bIndex]?.fields?.map(
            (field: any, index: number) => (
              <UserFilterCardForDm
                field={field}
                uID={uID}
                bIndex={bIndex}
                axisTitle={name}
                key={index}
                itemIndex={index}
                propKey={`${dynamicMeasureState.selectedTileId}.${dynamicMeasureState.selectedDynamicMeasureId}`}
              />
            ),
          )
        : !isFilterCollapsed &&
          currentChartAxes[bIndex]?.fields?.map((field: any, index: number) => (
            <UserFilterCard
              field={field}
              uID={uID || ''}
              bIndex={bIndex}
              axisTitle={name}
              key={index}
              itemIndex={index}
              propKey={propKey}
            />
          ))}
    </>
  );
};

export default ChartFilterCards;
